export const SET_BRAND = '[BRAND] SET BRAND';
export const REMOVE_BRAND = '[BRAND] REMOVE BRAND';

export function setBrand(value)
{
    return {
        type: SET_BRAND,
        payload: value
    };
}

export function removeBrand()
{
    return {
        type: REMOVE_BRAND
    }
}

